import { GTMEventName } from '../GTMEventName';
import type { Basket } from '../../../../bff-api/baskets/model';
import type { Product } from '../../../../bff-api/products/model';
import type { GTMEvent } from './GTMEvent';
import type { GTMSourceEvent } from './GTMSourceEvent';

export class GTMAddToBagEvent implements GTMEvent {
    event = GTMEventName.ADD_TO_BAG;

    source: GTMSourceEvent;

    bag: Basket;

    product: Product;

    constructor(source: GTMSourceEvent, bag: Basket, product: Product) {
        this.source = source;
        this.bag = bag;
        this.product = product;
    }
}
